






































































































































































import { Utils } from '@/helper/utils';
import { Component } from 'vue-property-decorator';
import { Base } from './base';

@Component({
  props: [
    'url',
    'customerKey',
    'vin',
    'amount',
    'totalAmount',
    'invoiceNumber',
    'tenantId',
    'enterpriseId',
    'storeId',
    'dealId',
    'storeName',
    'address',
    'zipcode',
    'city',
    'state',
    'phoneNumber',
    'firstName',
    'lastName',
    'comments',
    'transactionHeaderId',
    'lastPaymentDetailId',
    'loggedInUserId',
    'loggedInUserEmail',
    'customerEmail',
    'merchantEmail',
    'recordKey',
    'recordIdentifier',
    'type',
    'squareDialog',
    'showTextField',
    'other',
    'selectedCharges',
    'name',
    'account',
    'control',
    'reference',
    'description',
    'lineItems',
    'isAmountOverride',
    'isDeductiblePayment',
    'isSendPaymentReceipt',
    'amountWithServiceCharges',
    'isOverrideCCFeeApplied',
    'bypassReason'
  ],
})
export default class SquarePayment extends Base {
  public squareUrl: string = Utils.WEB_BASE_URL + '/serverpay/square';

  public close() {
    this.$emit('squareDialog', false);
  }
}
